import { useEffect, useState } from 'react';
import api from '../services/api';

export type EbookStatus = 'loading' | 'ok' | 'login' | 'trial' | 'notfound';

/**
 * Lien signé (2 h) vers un eBook, délivré par l'API aux seuls abonnés payants.
 * Les PDF ne sont plus publics : sans ce lien, pas de fichier.
 * - 'login'    : pas connecté
 * - 'trial'    : essai gratuit (403)
 * - 'notfound' : pas de PDF dans cette langue
 * Abonnement expiré (402) / session expirée (401) : redirection par l'intercepteur api.ts.
 */
export default function useEbookUrl(type?: string, id?: string, lang: 'fr' | 'ar' = 'fr') {
    const [url, setUrl] = useState<string | null>(null);
    const [status, setStatus] = useState<EbookStatus>('loading');

    useEffect(() => {
        setUrl(null);
        if (!type || !id) {
            setStatus('notfound');
            return;
        }
        if (!localStorage.getItem('token')) {
            setStatus('login');
            return;
        }
        setStatus('loading');
        let cancelled = false;
        api.get(`/ebook/${type}/${id}`, { params: { lang } })
            .then((res) => {
                if (cancelled) return;
                setUrl(res.data?.url || null);
                setStatus(res.data?.url ? 'ok' : 'notfound');
            })
            .catch((err) => {
                if (cancelled) return;
                const code = err.response?.status;
                if (code === 403) setStatus('trial');
                else if (code !== 401 && code !== 402) setStatus('notfound');
            });
        return () => { cancelled = true; };
    }, [type, id, lang]);

    return { url, status };
}
